import React from 'react';
import './header.css';
import logo from '../../assets/logo.png'
import Navheader from '../common/nav-header';
import { Link } from 'react-router-dom';
import pic1 from '../../assets/pic1.png';
import { useState } from 'react';

const Header = (props) => {

    const [isOpen, setIsOpen] = useState(false); 


    return ( 
     <header className='headerr'>
        <img src={logo} alt='logooo'></img>

        <nav className='navs-header'>
            <ul className='list-header'>
               <Link to="/" class='linksss'>
                  <Navheader stylee={props.homeActive} title='Home' />
               </Link>
               

               <Link to="/Propertieslist" class='linksss'>
                 <Navheader stylee={props.propertiesActive} title='Properties' />
               </Link>

                <Navheader stylee={props.contactActive} title='Contact' />
            </ul>
        </nav>

        <nav className='burger-menu'>
            <img src={pic1} alt='menu' onClick={() => setIsOpen(!isOpen)} ></img>
            
          {isOpen && (
            <nav className='navigation-menu'>
               <ul className='list-burger-menu'>
                   <Link to="/" class='linksss'>
                  <Navheader stylee={props.homeActive} title='Home' />
                  </Link>

                  <Link to="/Propertieslist" class='linksss'>
                  <Navheader stylee={props.propertiesActive} title='Properties' />
                  </Link>

                    <Navheader stylee={props.contactActive} title='Contact' />
               </ul>
            </nav>
            )}

        </nav>
     </header>
     );
}
 
export default Header;